export function createSearchDataSource(api, operation, parameters) {
    const top = 10;
    const p = parameters || {};
    return function load(q) {
        return api
            .request(operation, { parameters: { q, query: q, top: top, ...p } })
            .then(resp => resp.data);
    };
}
//# sourceMappingURL=searchDataSource.js.map